import React from 'react';
import styled from 'styled-components';

import NotificationBox, { BaseProps } from './Base';

export type ComponentProps = Omit<BaseProps, 'type'> & {
  /**
   * Text of the title for the Error message box
   */
  title: string;
  /**
   * Text to show under the title of the Error message box
   */
  value?: string | string[];

  titleProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
};

const ErrorTitle = styled.div`
  padding-right: 45px;
  font-size: 1.125rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  overflow-wrap: break-word;
  letter-spacing: -0.59px;
  margin-bottom: 15px;
`;

const ErrorInfoText = styled.div`
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  padding-bottom: 10px;
  line-height: 1.5;
  overflow-wrap: break-word;
  letter-spacing: -0.32px;
`;

const ErrorLinkText = styled.a`
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  padding-bottom: 10px;
  line-height: 1.5;
  overflow-wrap: break-word;
  text-decoration: underline;
  letter-spacing: -0.68px;
`;

function getTextParsed(Element: React.ComponentType, value: string | string[]) {
  if (value instanceof Array) {
    return value.map((item, i) => {
      return <Element key={`${item}_${i}`}>{item}</Element>;
    });
  }
  return <Element>{value}</Element>;
}

/**
 * Form field error box
 */
export const Field: React.FC<ComponentProps> = ({
  title,
  value,
  children,
  titleProps,
  ...rest
}) => {
  return (
    <NotificationBox type='Error' {...rest}>
      {title && <ErrorTitle {...titleProps}>{title}</ErrorTitle>}
      {children || getTextParsed(ErrorLinkText, value || '')}
    </NotificationBox>
  );
};

/**
 * General error box
 */
export const Text: React.FC<ComponentProps> = ({
  title,
  value: text,
  children,
  titleProps,
  ...rest
}) => {
  return (
    <NotificationBox type='Error' {...rest}>
      {title && <ErrorTitle {...titleProps}>{title}</ErrorTitle>}
      {children || getTextParsed(ErrorInfoText, text || '')}
    </NotificationBox>
  );
};

export default {
  Field,
  Text
};
